const SEO = ({ title, description }) => (
  <>
    <title>{title}</title>
    <meta name="description" content={description} />
  </>
);

export default SEO;
